<template>
    <span :class="color">{{ pct }}</span>
</template>

<script>
export default {
    data: () => ({
        pct: 0,
        color: ""
    }),
    props: ["value"],
    mounted () {
        this.refresh();
    },
    methods: {
        refresh() {
            if (this.value === undefined) {
                this.pct = "∞";
                this.color = "growth green-text";

                return;
            }

            this.pct = (this.value >= 0 ? ("+" + this.value) : this.value) + "%";

            if (this.value > 0)
                this.color = "growth green--text";
            else if (this.value < 0)
                this.color = "growth red--text";
            else
                this.color = "growth";
        }
    },
    watch: {
        value() { this.refresh(); }
    }
}
</script>